var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"py-1",attrs:{"md":"8"}},[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }